import SessionManager from "./auth/sessionmanager";
import Login from "./auth/Login";

const PrivateComponent = ({ children }) => {

    const isLoggedIn = SessionManager.getToken();

    return isLoggedIn ? children : <Login/>;
}

export default PrivateComponent;